export const TRUE_PRODUCTION_DOMAIN = "next.rshb.ru";
